import React from "react";
import { Link } from "react-router-dom";

const BannerCollection = ({
  image,
  title,
  subtitle,
  buttonText,
  buttonLink,
}) => {
  return (
    <section className="flat-spacing-10">
      <div className="container">
        <div className="tf-banner-collection text-center">
          <img
            className="lazyload radius-10"
            data-src={image}
            src={image}
            alt="img-banner"
            loading="lazy"
          />
          <div className="box-content w-100">
            <div className="container wow fadeInUp" data-wow-delay="0s">
              {title && <h2 className="heading fw-6 text_white">{title}</h2>}
              {subtitle && <p className="text_white">{subtitle}</p>}
              {buttonText && (
                <Link
                  to={buttonLink || "/shop/collection"}
                  className="tf-btn btn-line btn-line-light collection-other-link fw-6"
                >
                  <span>{buttonText}</span>
                  <i className="icon icon-arrow1-top-left"></i>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerCollection;
